// Device fingerprint payload required by Login/GenerateOTP, ValidateOTP,
// and Profile/UpdateUserProfile. Built from available browser signals.
export const buildFingerprint = () => ({
  deviceId: (navigator.userAgent || 'web').slice(0, 64),
  appVersion: '1.0.0',
  buildNumber: 1,
  connectionType: navigator?.connection?.effectiveType || '4g',
  location: { latitude: 0, longitude: 0 },
  deviceData: {
    platform: navigator.platform || 'web',
    model: 'browser',
    brand: 'web',
    version: (navigator.appVersion || '1.0').slice(0, 32),
    sdkInt: 0,
    isPhysicalDevice: false,
    identifierForVendor: '',
  },
  publicIp: '',
  timestamp: new Date().toISOString(),
});
